import { Navigate, createFileRoute } from "@tanstack/react-router";

import { useCurrentVenueQuery } from "../../../hooks/venues";

const Component = () => {
  const { data: venue } = useCurrentVenueQuery();
  if (venue && venue.climbTypes) {
    return (
      <Navigate
        to={`/gym/$venueUuid/archive/$climbType`}
        params={{ venueUuid: venue.uuid, climbType: venue.climbTypes[0] }}
        search={{ tab: "maps" }}
      />
    );
  }
  return null;
};

export const Route = createFileRoute("/gym/$venueUuid/archive/")({
  component: Component,
});
